import { Button, ButtonGroup, Modal } from "@datapay-by-datacom/design-system";
import { Heading } from "react-aria-components";
import type {
  CompanyTemplateRef,
  MyPayEnvironment,
} from "../../generated/core-api";
import s from "./ReplaceCompanyCsvConfirmModal.module.css";

export interface CommitCompaniesConfirmModalProps {
  isOpen: boolean;
  companyCount: number;
  environment: MyPayEnvironment;
  template: CompanyTemplateRef;
  templateDisplayName?: string;
  onCancel: () => void;
  onConfirm: () => void;
}

export function CommitCompaniesConfirmModal({
  isOpen,
  companyCount,
  environment,
  template,
  templateDisplayName,
  onCancel,
  onConfirm,
}: CommitCompaniesConfirmModalProps) {
  return (
    <Modal isOpen={isOpen}>
      <div className={s.modalContent}>
        <Heading slot="title" className={s.title}>
          Create these companies?
        </Heading>
        <dl className={s.summary}>
          <dt className={s.summaryLabel}>Companies</dt>
          <dd className={s.summaryValue}>{companyCount}</dd>
          <dt className={s.summaryLabel}>Environment</dt>
          <dd className={s.summaryValue}>{environment}</dd>
          <dt className={s.summaryLabel}>Template</dt>
          <dd className={s.summaryValue}>
            {templateDisplayName
              ? `${templateDisplayName} (${template.config_code}, version ${template.version})`
              : `${template.config_code} (version ${template.version})`}
          </dd>
        </dl>
        <p className={s.warning}>
          Company creation cannot be undone.
        </p>
        <div className={s.actions}>
          <ButtonGroup>
            <Button variant="tertiary" onPress={onCancel}>
              Cancel
            </Button>
            <Button variant="primary" onPress={onConfirm}>
              Create companies
            </Button>
          </ButtonGroup>
        </div>
      </div>
    </Modal>
  );
}
